import React from 'react';
import { Instagram, Phone, Globe, MessageCircle, MapPin } from 'lucide-react';
import { mockData } from '../mock';
import logo from '../assets/images/logo.png';

export const Links = () => {
  const links = [
    {
      title: 'Falar no WhatsApp',
      url: `https://wa.me/${mockData.company.whatsapp}`,
      icon: <MessageCircle className="w-6 h-6" />,
      color: 'bg-green-600 hover:bg-green-700'
    },
    {
      title: 'Instagram Oficial',
      url: mockData.company.social.instagram,
      icon: <Instagram className="w-6 h-6" />,
      color: 'bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 hover:opacity-90'
    },
    {
      title: 'Ver Galeria de Fotos',
      url: '/galeria',
      isInternal: true,
      icon: <Globe className="w-6 h-6" />,
      color: 'bg-blue-600 hover:bg-blue-700'
    },
    {
      title: 'Nossa Localização',
      url: 'https://goo.gl/maps/seumapaaqui', // Ajuste conforme necessário
      icon: <MapPin className="w-6 h-6" />,
      color: 'bg-red-600 hover:bg-red-700'
    },
    {
      title: 'Ligar Agora',
      url: `tel:${mockData.company.phone}`,
      icon: <Phone className="w-6 h-6" />,
      color: 'bg-slate-800 hover:bg-slate-900'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center px-4 py-12">
      {/* Header do Linktree */}
      <div className="flex flex-col items-center mb-10">
        <div className="mb-4 p-4 bg-white rounded-2xl shadow-sm border border-slate-100">
          <img 
            src={logo} 
            alt={mockData.company.name} 
            className="h-20 w-auto object-contain"
          />
        </div>
        <h1 className="text-2xl font-bold text-slate-900">{mockData.company.name}</h1>
        <p className="text-slate-600 mt-2 text-center max-w-xs">
          {mockData.company.tagline}
        </p>
      </div>

      {/* Botões */}
      <div className="w-full max-w-md space-y-4">
        {links.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target={link.isInternal ? '_self' : '_blank'}
            rel="noopener noreferrer"
            className={`flex items-center justify-between p-4 rounded-xl text-white font-bold transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-md hover:shadow-lg ${link.color}`}
          >
            <div className="flex items-center space-x-4">
              {link.icon}
              <span>{link.title}</span>
            </div>
            <div className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-full">
              <span className="text-lg">→</span>
            </div>
          </a>
        ))}
      </div>

      {/* Footer */}
      <div className="mt-auto pt-10 text-slate-400 text-sm">
        © {new Date().getFullYear()} {mockData.company.name}
      </div>
    </div>
  );
};
